// ABOUTME: Thin PostHog analytics wrapper for event tracking, user identification, and customer grouping.
// ABOUTME: Abstracts the provider so instrumentation code doesn't depend directly on posthog-js.

import posthog from "posthog-js";

let initialized = false;

export const analytics = {
  init(apiKey: string, apiHost: string) {
    if (initialized) return;
    posthog.init(apiKey, {
      api_host: apiHost,
      ui_host: "https://us.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: "[data-ph-mask]",
      },
      autocapture: true,
    });
    initialized = true;
  },

  identify(userId: string, traits?: Record<string, unknown>) {
    if (!initialized) return;
    posthog.identify(userId, traits);
  },

  group(customerId: string, traits?: Record<string, unknown>) {
    if (!initialized) return;
    posthog.group("customer", customerId, traits);
  },

  track(event: string, properties?: Record<string, unknown>) {
    if (!initialized) return;
    posthog.capture(event, properties);
  },

  reset() {
    if (!initialized) return;
    posthog.reset();
  },
};
